import UploadOneDrive from '../components/UploadOneDrive';
import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import { formatDate, formatEuro, clienteNome, statoLabel, Modal, ConfirmDialog, LoadingSpinner, Pagination } from '../components/shared';

const PERIODI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre','I Trimestre','II Trimestre','III Trimestre','IV Trimestre','Annuale'];

// ─── INPUT ANNO LIBERO ────────────────────────────────────────────────────────
function AnnoInput({ value, onChange, placeholder = 'Anno…', style = {} }) {
  return (
    <input
      type="number"
      min="1990" max="2099"
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      style={{ width: 90, textAlign: 'center', fontFamily: 'monospace', ...style }}
      className="form-control"
    />
  );
}


function IVAForm({ initial = {}, clientiList, onSave, onClose, loading }) {
  const [d, setD] = useState({
    id_cliente: '', tipo: 'IVA', descrizione: '', data_scad: '',
    importo: '', stato: 'APERTA', note: '', ...initial,
    id_cliente: initial.id_cliente || '',
    importo: initial.importo || '',
  });
  const [periodo, setPeriodo] = useState('Annuale');
  const [anno, setAnno]       = useState(() => {
    // Per modifiche: usa anno_imposta se presente, altrimenti estrai dalla descrizione
    if (initial.anno_imposta) return parseInt(initial.anno_imposta);
    // Cerca solo pattern "IVA XXXX" o "Annuale XXXX" nella descrizione, non numeri generici
    const match = (initial.descrizione||'').match(/\bIVA\s+(20\d{2})\b|\bAnnuale\s+(20\d{2})\b|\b(20\d{2})\s*$/);
    if (match) return parseInt(match[1]||match[2]||match[3]);
    return new Date().getFullYear();
  });
  const set = (k, v) => setD(p => ({ ...p, [k]: v }));

  const buildDesc = () => `Dichiarazione IVA ${periodo} ${anno}`;

  const [modalita, setModalita] = useState(d.modalita_bulk || 'singolo');
  const isBulk = modalita !== 'singolo';
  const counts = { tutti: clientiList.length, pf: clientiList.filter(c=>c.tipo==='PF').length, pg: clientiList.filter(c=>c.tipo==='PG').length };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      const annoStr = String(anno).trim();
      const descCampo = d.descrizione ? d.descrizione.trim() : '';
      const desc = descCampo !== '' ? descCampo : `Dichiarazione IVA ${periodo} ${annoStr}`;
      onSave({ ...d, modalita_bulk: modalita, descrizione: desc, anno_imposta: annoStr });
    }}>
      {!d.id && (
        <div style={{marginBottom:16}}>
          <div className="form-label" style={{marginBottom:8}}>Destinatari</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:6}}>
            {[['singolo','Cliente singolo',null],['tutti','Tutti i clienti',counts.tutti],['pf','Solo PF',counts.pf],['pg','Solo PG',counts.pg]].map(([k,l,n])=>(
              <button key={k} type="button" onClick={()=>setModalita(k)} style={{padding:'8px 12px',borderRadius:'var(--radius-sm)',textAlign:'left',border:`2px solid ${modalita===k?'var(--accent)':'var(--border-strong)'}`,background:modalita===k?'var(--accent-light)':'var(--surface)',cursor:'pointer'}}>
                <div style={{fontSize:12.5,fontWeight:500,color:modalita===k?'var(--accent)':'var(--text)'}}>{l}</div>
                {n!=null&&<div style={{fontSize:11,color:'var(--text-faint)'}}>{n} clienti</div>}
              </button>
            ))}
          </div>
          {isBulk&&<div style={{marginTop:8,padding:'8px 12px',background:'#FAEEDA',border:'1px solid #FAC775',borderRadius:'var(--radius-sm)',fontSize:12,color:'#854F0B'}}>⚠ Verranno create <strong>{counts[modalita]}</strong> dichiarazioni separate</div>}
        </div>
      )}
      <div className="form-grid">
        {!isBulk && <div className="form-group">
          <label className="form-label">Cliente</label>
          <select className="form-control" value={d.id_cliente} onChange={e => set('id_cliente', e.target.value)}>
            <option value="">— Seleziona cliente —</option>
            {clientiList.map(c => <option key={c.id} value={c.id}>{clienteNome(c)} ({c.codice})</option>)}
          </select>
        </div>}
        <div className="form-group">
          <label className="form-label">Anno d'imposta</label>
          <AnnoInput value={anno} onChange={setAnno} placeholder="Es. 2024" />
        </div>
        <div className="form-group">
          <label className="form-label">Periodo</label>
          <select className="form-control" value={periodo} onChange={e => setPeriodo(e.target.value)}>
            {PERIODI.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Data Scadenza *</label>
          <input className="form-control" type="date" value={d.data_scad} onChange={e => set('data_scad', e.target.value)} required />
        </div>
        <div className="form-group form-full">
          <label className="form-label">Descrizione</label>
          <input className="form-control" value={d.descrizione} onChange={e => set('descrizione', e.target.value)} placeholder={`Dichiarazione IVA ${periodo} ${anno}`} />
        </div>
        <div className="form-group">
          <label className="form-label">IVA a debito (€)</label>
          <input className="form-control" type="number" step="0.01" value={d.importo} onChange={e => set('importo', e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Stato</label>
          <select className="form-control" value={d.stato} onChange={e => set('stato', e.target.value)}>
            <option value="APERTA">Aperta</option>
            <option value="PREPARATA">Preparata</option>
            <option value="INVIATA">Inviata</option>
            <option value="SOSPESA">Sospesa</option>
            <option value="NON_PREVISTA">Non prevista</option>
            <option value="ALTRO">Altro</option>
          </select>
        </div>
        <div className="form-group form-full">
          <label className="form-label">Note</label>
          <textarea className="form-control" value={d.note} onChange={e => set('note', e.target.value)} rows={3} />
        </div>
      </div>
      <div className="modal-footer" style={{ padding:'16px 0 0', borderTop:'1px solid var(--border)', marginTop:20 }}>
        <button type="button" className="btn" onClick={onClose}>Annulla</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Salvataggio…' : isBulk ? `Crea ${counts[modalita]} dichiarazioni` : 'Salva'}</button>
      </div>
    </form>
  );
}


// ─── SORTABLE TH ─────────────────────────────────────────────────────────────
function SortTh({ label, field, sort, dir, onSort }) {
  const active = sort === field;
  return (
    <th onClick={() => onSort(field)} style={{
      cursor:'pointer', userSelect:'none', whiteSpace:'nowrap',
      color: active ? 'var(--accent)' : undefined,
      background: active ? 'var(--accent-light)' : undefined,
    }}>
      {label}{active ? (dir==='asc' ? ' ↑' : ' ↓') : ''}
    </th>
  );
}


const MESI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
              'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

// 13 periodi: mesi 1-12 + acconto (mese 0 = acconto novembre)
const PERIODI_IVA = [
  ...Array.from({length:11}, (_,i) => ({ mese:i+1, label: MESI[i] })),
  { mese:0,  label:'Acconto IVA (Novembre)' },
  { mese:12, label:'Dicembre' },
];

function euro(v) {
  if (!v && v!==0) return '—';
  return new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(v);
}


// ─── PANNELLO CASSETTO FISCALE ────────────────────────────────────────────────
function CassettoFiscale({ idScadenza, onImportato }) {
  const [stato, setStato]   = useState('idle');
  const [inCorso, setInCorso] = useState(false);
  const [data, setData]     = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [aperto, setAperto] = useState(false);
  const pollRef             = React.useRef(null);

  const pollStato = () => {
    fetch('/api/cassetto/stato').then(r=>r.json()).then(j => {
      if (!j.success) return;
      setStato(j.data.status);
      setInCorso(j.data.inCorso);
      if (j.data.data) { setData(j.data.data); clearInterval(pollRef.current); }
      if (!j.data.inCorso && j.data.status !== 'idle') clearInterval(pollRef.current);
    });
  };

  const avvia = async () => {
    const res = await fetch('/api/cassetto/avvia', { method:'POST' });
    const j   = await res.json();
    if (!j.success) { alert(j.error); return; }
    setInCorso(true); setData(null); setSelected(new Set());
    pollRef.current = setInterval(pollStato, 2000);
  };

  const reset = async () => {
    await fetch('/api/cassetto/reset', { method:'POST' });
    setStato('idle'); setInCorso(false); setData(null); setSelected(new Set());
  };

  const toggleSel = (i) => setSelected(prev => {
    const s = new Set(prev); s.has(i) ? s.delete(i) : s.add(i); return s;
  });

  const importa = async () => {
    const vers = [...selected].map(i => data[i]);
    const res = await fetch('/api/cassetto/importa', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ versamenti: vers, id_scadenza: idScadenza })
    });
    const j = await res.json();
    if (j.success) { alert(`Importati ${j.data.importati} versamenti`); onImportato(); setAperto(false); }
  };

  if (!aperto) return (
    <button className="btn btn-sm" style={{ marginLeft:8 }} onClick={() => setAperto(true)}>
      🏛 Cassetto Fiscale
    </button>
  );

  return (
    <div style={{ marginTop:16, padding:'16px', background:'var(--bg)',
      border:'1px solid var(--border)', borderRadius:'var(--radius)', }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
        <span style={{ fontWeight:600, fontSize:14 }}>🏛 Cassetto Fiscale — Agenzia Entrate</span>
        <button className="btn btn-sm" onClick={() => setAperto(false)} style={{ marginLeft:'auto' }}>×</button>
      </div>

      <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:12, padding:'8px 12px',
        background:'var(--accent-light)', borderRadius:'var(--radius-sm)' }}>
        ℹ Apre Chrome, naviga al cassetto fiscale e attende il tuo login SPID. 
        Dopo l'autenticazione scarica automaticamente i versamenti F24.
      </div>

      {/* Stato */}
      {stato !== 'idle' && (
        <div style={{ marginBottom:12, padding:'8px 12px', background:'var(--surface)',
          borderRadius:'var(--radius-sm)', fontSize:12, display:'flex', alignItems:'center', gap:8 }}>
          {inCorso && <div style={{ width:10, height:10, borderRadius:'50%',
            background:'var(--c-amber)', animation:'pulse 1s infinite' }} />}
          <span>{stato}</span>
        </div>
      )}

      {/* Azioni */}
      <div style={{ display:'flex', gap:8, marginBottom: data ? 16 : 0 }}>
        <button className="btn btn-primary btn-sm" onClick={avvia}
          disabled={inCorso}>
          {inCorso ? '⏳ In corso…' : '▶ Avvia recupero'}
        </button>
        {stato !== 'idle' && (
          <button className="btn btn-sm" onClick={reset}>↺ Reset</button>
        )}
      </div>

      {/* Risultati */}
      {data && data.length > 0 && (
        <div>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
            <span style={{ fontSize:13, fontWeight:500 }}>
              Trovati {data.length} versamenti — seleziona quelli da importare:
            </span>
            <button className="btn btn-sm" onClick={() => setSelected(new Set(data.map((_,i)=>i)))}>
              Tutti
            </button>
          </div>
          <div style={{ maxHeight:200, overflow:'auto', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
              <thead><tr style={{ background:'var(--bg)', position:'sticky', top:0 }}>
                <th style={{ padding:'6px 10px', width:30 }}></th>
                <th style={{ padding:'6px 10px', textAlign:'left' }}>Data</th>
                <th style={{ padding:'6px 10px', textAlign:'right' }}>Importo</th>
                <th style={{ padding:'6px 10px', textAlign:'left' }}>Cod. Tributo</th>
                <th style={{ padding:'6px 10px', textAlign:'left' }}>Note</th>
              </tr></thead>
              <tbody>
                {data.map((v,i) => (
                  <tr key={i} style={{ borderBottom:'1px solid var(--border)',
                    background: selected.has(i) ? 'var(--accent-light)' : i%2===0?'var(--surface)':'var(--bg)' }}>
                    <td style={{ padding:'5px 10px', textAlign:'center' }}>
                      <input type="checkbox" checked={selected.has(i)} onChange={()=>toggleSel(i)}
                        style={{ accentColor:'var(--accent)', cursor:'pointer' }} />
                    </td>
                    <td style={{ padding:'5px 10px' }}>{v.data_vers}</td>
                    <td style={{ padding:'5px 10px', textAlign:'right', fontFamily:'monospace', fontWeight:500 }}>
                      {new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(v.importo)}
                    </td>
                    <td style={{ padding:'5px 10px', fontFamily:'monospace' }}>{v.codice_tributo||'—'}</td>
                    <td style={{ padding:'5px 10px', color:'var(--text-faint)', fontSize:11 }}>
                      {v.raw?.slice(0,50)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button className="btn btn-primary btn-sm" style={{ marginTop:10 }}
            disabled={!selected.size} onClick={importa}>
            ⬇ Importa {selected.size} versamenti selezionati
          </button>
        </div>
      )}
      {data && data.length === 0 && (
        <div style={{ fontSize:13, color:'var(--text-faint)', padding:'12px 0' }}>
          Nessun versamento trovato. La struttura della pagina potrebbe essere cambiata.
        </div>
      )}
    </div>
  );
}

function IVADettaglio({ scadenza, onClose, addToast }) {
  const [det, setDet]         = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [annoLiq, setAnnoLiq] = useState(() => {
    // Usa anno_imposta salvato nel DB, altrimenti cerca solo pattern "IVA XXXX" nella descrizione
    if (scadenza.anno_imposta) return parseInt(scadenza.anno_imposta);
    const match = (scadenza.descrizione||'').match(/\bIVA\s+(20\d{2})\b|\b(20\d{2})\s*$/);
    return match ? parseInt(match[1]||match[2]) : new Date().getFullYear();
  });

  // liq: oggetto keyed by mese (0-12)
  const [liq, setLiq] = useState(() => {
    const obj = {};
    PERIODI_IVA.forEach(p => { obj[p.mese] = { mese:p.mese, debito:'', credito:'', note:'' }; });
    return obj;
  });

  // Versamenti per mese
  const [newVers, setNewVers] = useState({});
  const [allegati, setAllegati] = useState([]);
  const [importingPdf, setImportingPdf] = useState(false);
  const pdfImportRef = React.useRef();
  const [uploading, setUploading] = useState(false);
  const fileRef = React.useRef(); // { [mese]: {data_vers,importo,note} }

  const load = () => {
    setLoading(true);
    fetch(`/api/iva/${scadenza.id}/dettaglio`).then(r=>r.json())
      .then(j => {
        if (!j.success) return;
        setDet(j.data);
        const obj = {};
        PERIODI_IVA.forEach(p => { obj[p.mese] = { mese:p.mese, debito:'', credito:'', note:'' }; });
        j.data.liquidazioni.forEach(x => {
          obj[x.mese] = { mese:x.mese, debito:x.debito||'', credito:x.credito||'', note:x.note||'' };
          if (x.anno) setAnnoLiq(x.anno);
        });
        setLiq(obj);
      })
      .finally(() => setLoading(false));

    // Carica allegati
    fetch(`/api/iva/${scadenza.id}/allegati`).then(r=>r.json())
      .then(j => { if(j.success) setAllegati(j.data); });
  };
  useEffect(() => { load(); }, [scadenza.id]);

  const uploadAllegato = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData(); fd.append('file', file);
      const res = await fetch(`/api/iva/${scadenza.id}/allegati`, { method:'POST', body:fd });
      const j = await res.json();
      if (!j.success) throw new Error(j.error);
      load();
    } catch(e) { alert(e.message); }
    finally { setUploading(false); }
  };

  const deleteAllegato = async (id) => {
    await fetch(`/api/iva/${scadenza.id}/allegati/${id}`, { method:'DELETE' });
    load();
  };

  const importaPdf = async (file) => {
    if (!file) return;
    setImportingPdf(true);
    try {
      const fd = new FormData();
      fd.append('pdf', file);
      const res = await fetch(`/api/iva/${scadenza.id}/importa-pdf`, { method:'POST', body:fd });
      const j = await res.json();
      if (!j.success) throw new Error(j.error);
      alert(`✅ Importati ${j.data.inseriti} versamenti su ${j.data.trovati} trovati nel PDF`);
      load();
    } catch(e) { alert('❌ ' + e.message); }
    finally { setImportingPdf(false); if(pdfImportRef.current) pdfImportRef.current.value=''; }
  };

  const fileIcon = (nome) => {
    const ext = (nome||'').split('.').pop().toLowerCase();
    if (ext==='pdf') return '📄';
    if (['jpg','jpeg','png'].includes(ext)) return '🖼️';
    if (['doc','docx'].includes(ext)) return '📝';
    if (['xls','xlsx'].includes(ext)) return '📊';
    return '📎';
  };

  const setLiqField = (mese, field, val) =>
    setLiq(prev => ({ ...prev, [mese]: { ...prev[mese], [field]: val } }));

  const saveLiq = async () => {
    setSaving(true);
    try {
      const liquidazioni = Object.values(liq).filter(l => l.debito||l.credito||l.note);
      const res = await fetch(`/api/iva/${scadenza.id}/liquidazioni`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ liquidazioni, anno: annoLiq })
      });
      const j = await res.json();
      if (!j.success) throw new Error(j.error);
      load();
    } catch(e) { alert(e.message); }
    finally { setSaving(false); }
  };

  const addVers = async (mese) => {
    const v = newVers[mese] || {};
    if (!v.data_vers || !v.importo) { alert('Inserisci data e importo'); return; }
    const res = await fetch(`/api/iva/${scadenza.id}/versamenti`, {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ ...v, mese })
    });
    const j = await res.json();
    if (j.success) {
      setNewVers(prev => ({ ...prev, [mese]: { data_vers:'', importo:'', note:'' } }));
      load();
    }
  };

  const delVers = async (id) => {
    await fetch(`/api/iva/versamenti/${id}`, { method:'DELETE' });
    load();
  };

  const getVers = (mese) => det ? det.versamenti.filter(v => v.mese === mese) : [];
  const totVersati = (mese) => getVers(mese).reduce((s,v) => s + (v.importo||0), 0);
  const getNewVers = (mese) => newVers[mese] || { data_vers:'', importo:'', note:'' };
  const setNV = (mese, field, val) =>
    setNewVers(prev => ({ ...prev, [mese]: { ...getNewVers(mese), [field]: val } }));

  return (
    <div className="modal-backdrop" onClick={e => { if(e.target===e.currentTarget) onClose(); }}>
      <div style={{
        background:'var(--surface)', borderRadius:'var(--radius)',
        boxShadow:'0 20px 60px rgba(0,0,0,0.25)',
        width:'96vw', maxWidth:1200, maxHeight:'94vh',
        display:'flex', flexDirection:'column', overflow:'hidden',
      }}>
        {/* Header */}
        <div style={{ padding:'14px 20px', borderBottom:'1px solid var(--border)',
          display:'flex', alignItems:'center', gap:12, flexShrink:0 }}>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:600, fontSize:15 }}>
              {scadenza.descrizione || 'Dichiarazione IVA'} — {clienteNome(scadenza)}
            </div>
            <div style={{ fontSize:12, color:'var(--text-faint)', marginTop:2 }}>
              Scadenza: {formatDate(scadenza.data_scad)}
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:12, color:'var(--text-faint)' }}>Anno:</span>
            <input type="number" min="2000" max="2099" value={annoLiq}
              onChange={e=>setAnnoLiq(e.target.value)}
              style={{ width:80, fontFamily:'monospace', textAlign:'center',
                padding:'4px 8px', border:'1px solid var(--border)',
                borderRadius:'var(--radius-sm)', background:'var(--bg)', fontSize:13 }} />
          </div>
          <button className="btn btn-primary btn-sm" onClick={saveLiq} disabled={saving}>
            {saving ? 'Salvo…' : '💾 Salva'}
          </button>
          <input ref={pdfImportRef} type="file" accept=".pdf" style={{ display:'none' }}
            onChange={e => importaPdf(e.target.files[0])} />
          <button className="btn btn-sm" onClick={() => pdfImportRef.current.click()}
            disabled={importingPdf} title="Importa versamenti da PDF cassetto fiscale"
            style={{ background:'#DC2626', color:'white', border:'none' }}>
            {importingPdf ? '⏳ Importo…' : '📥 Importa PDF F24'}
          </button>
          <CassettoFiscale idScadenza={scadenza.id} onImportato={load} />
          <button onClick={onClose} style={{ border:'none', background:'none',
            fontSize:22, cursor:'pointer', color:'var(--text-faint)', lineHeight:1 }}>×</button>
        </div>

        <div style={{ flex:1, overflow:'auto', padding:'16px 20px' }}>
          {loading ? (
            <div style={{textAlign:'center',padding:40,color:'var(--text-faint)'}}>Caricamento…</div>
          ) : (
            <div>
              {/* ── Tabella periodi ─────────────────────────────────── */}
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                <thead>
                  <tr style={{ background:'var(--bg)', position:'sticky', top:0, zIndex:1 }}>
                    {['Periodo','Debito (€)','Credito (€)','Saldo periodo',
                      'Versamenti del periodo','Versato','Differenza','Note'].map(h => (
                      <th key={h} style={{ padding:'8px 10px', textAlign:'left',
                        fontSize:11, fontWeight:600, color:'var(--text-faint)',
                        textTransform:'uppercase', letterSpacing:'0.4px',
                        borderBottom:'2px solid var(--border)', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {PERIODI_IVA.map((periodo, idx) => {
                    const l      = liq[periodo.mese] || { debito:'', credito:'', note:'' };
                    const deb    = parseFloat(l.debito)||0;
                    const cre    = parseFloat(l.credito)||0;
                    const saldo  = deb - cre;
                    const vers   = getVers(periodo.mese);
                    const totV   = totVersati(periodo.mese);
                    const diff   = saldo - totV;
                    const nv     = getNewVers(periodo.mese);
                    const isAcconto = periodo.mese === 0;

                    return (
                      <tr key={periodo.mese} style={{
                        borderBottom:'1px solid var(--border)',
                        background: isAcconto
                          ? 'rgba(139,92,246,0.06)'
                          : idx%2===0 ? 'var(--surface)' : 'var(--bg)',
                      }}>
                        {/* Nome periodo */}
                        <td style={{ padding:'8px 10px', fontWeight:isAcconto?700:500,
                          color:isAcconto?'#7C3AED':'var(--text)',
                          borderLeft:isAcconto?'3px solid #7C3AED':'3px solid transparent',
                          whiteSpace:'nowrap' }}>
                          {periodo.label}
                        </td>

                        {/* Debito */}
                        <td style={{ padding:'6px 8px' }}>
                          <input type="number" step="0.01" min="0" value={l.debito}
                            onChange={e=>setLiqField(periodo.mese,'debito',e.target.value)}
                            placeholder="0,00"
                            style={{ width:100, padding:'4px 6px', border:'1px solid var(--border)',
                              borderRadius:'var(--radius-sm)', fontFamily:'monospace', fontSize:12,
                              background:'var(--surface)', textAlign:'right' }} />
                        </td>

                        {/* Credito */}
                        <td style={{ padding:'6px 8px' }}>
                          <input type="number" step="0.01" min="0" value={l.credito}
                            onChange={e=>setLiqField(periodo.mese,'credito',e.target.value)}
                            placeholder="0,00"
                            style={{ width:100, padding:'4px 6px', border:'1px solid var(--border)',
                              borderRadius:'var(--radius-sm)', fontFamily:'monospace', fontSize:12,
                              background:'var(--surface)', textAlign:'right' }} />
                        </td>

                        {/* Saldo periodo */}
                        <td style={{ padding:'8px 10px', fontFamily:'monospace', fontSize:12,
                          fontWeight:saldo!==0?600:400,
                          color:saldo>0?'var(--c-red)':saldo<0?'var(--c-green)':'var(--text-faint)' }}>
                          {deb||cre ? (saldo>0?'':'+')+(-saldo).toFixed(2).replace('-','')+(saldo>0?' D':' C') : '—'}
                        </td>

                        {/* Versamenti del periodo */}
                        <td style={{ padding:'6px 8px', minWidth:220 }}>
                          {/* Lista versamenti esistenti */}
                          {vers.map(v => (
                            <div key={v.id} style={{ display:'flex', alignItems:'center', gap:6,
                              marginBottom:4, padding:'3px 6px', background:'var(--bg)',
                              borderRadius:'var(--radius-sm)', border:'1px solid var(--border)' }}>
                              <span style={{ fontSize:11, color:'var(--text-faint)', whiteSpace:'nowrap' }}>
                                {formatDate(v.data_vers)}
                              </span>
                              <span style={{ fontFamily:'monospace', fontSize:12, fontWeight:500, flex:1 }}>
                                {euro(v.importo)}
                              </span>
                              {v.note && <span style={{ fontSize:10, color:'var(--text-faint)' }}>{v.note}</span>}
                              <button onClick={() => delVers(v.id)}
                                style={{ border:'none', background:'none', cursor:'pointer',
                                  color:'var(--c-red)', fontSize:14, lineHeight:1, padding:'0 2px' }}>×</button>
                            </div>
                          ))}
                          {/* Form nuovo versamento */}
                          <div style={{ display:'flex', gap:4, alignItems:'center', marginTop:4 }}>
                            <input type="date" value={nv.data_vers}
                              onChange={e=>setNV(periodo.mese,'data_vers',e.target.value)}
                              style={{ width:120, padding:'3px 5px', border:'1px solid var(--border)',
                                borderRadius:'var(--radius-sm)', fontSize:11, background:'var(--bg)' }} />
                            <input type="number" step="0.01" value={nv.importo}
                              onChange={e=>setNV(periodo.mese,'importo',e.target.value)}
                              placeholder="€"
                              style={{ width:80, padding:'3px 5px', border:'1px solid var(--border)',
                                borderRadius:'var(--radius-sm)', fontFamily:'monospace', fontSize:11,
                                background:'var(--bg)', textAlign:'right' }} />
                            <input type="text" value={nv.note}
                              onChange={e=>setNV(periodo.mese,'note',e.target.value)}
                              placeholder="Note"
                              style={{ width:70, padding:'3px 5px', border:'1px solid var(--border)',
                                borderRadius:'var(--radius-sm)', fontSize:11, background:'var(--bg)' }} />
                            <button onClick={() => addVers(periodo.mese)}
                              style={{ padding:'3px 8px', background:'var(--accent)', color:'white',
                                border:'none', borderRadius:'var(--radius-sm)', cursor:'pointer',
                                fontSize:12, fontWeight:600, whiteSpace:'nowrap' }}>+</button>
                          </div>
                        </td>

                        {/* Totale versato */}
                        <td style={{ padding:'8px 10px', fontFamily:'monospace', fontSize:12,
                          fontWeight:totV>0?600:400,
                          color:totV>0?'var(--accent)':'var(--text-faint)' }}>
                          {totV>0 ? euro(totV) : '—'}
                        </td>

                        {/* Differenza */}
                        <td style={{ padding:'8px 10px', fontFamily:'monospace', fontSize:12, fontWeight:600,
                          color: (deb||cre) && Math.abs(diff)>0.005
                            ? diff>0 ? 'var(--c-red)' : 'var(--c-green)'
                            : 'var(--text-faint)' }}>
                          {(deb||cre||totV)
                            ? diff===0 ? '✓' : (diff>0?'':'+')+(-diff).toFixed(2).replace('-','')+(diff>0?' D':' C')
                            : '—'}
                        </td>

                        {/* Note */}
                        <td style={{ padding:'6px 8px' }}>
                          <input type="text" value={l.note}
                            onChange={e=>setLiqField(periodo.mese,'note',e.target.value)}
                            placeholder="Note…"
                            style={{ width:110, padding:'4px 6px', border:'1px solid var(--border)',
                              borderRadius:'var(--radius-sm)', fontSize:12, background:'var(--surface)' }} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

                {/* Riga totali */}
                <tfoot>
                  <tr style={{ background:'var(--accent-light)', borderTop:'2px solid var(--border)' }}>
                    <td style={{ padding:'10px', fontWeight:700 }}>TOTALE ANNUALE</td>
                    <td style={{ padding:'10px', fontFamily:'monospace', fontWeight:700, color:'var(--c-red)' }}>
                      {euro(Object.values(liq).reduce((s,l)=>s+(parseFloat(l.debito)||0),0))}
                    </td>
                    <td style={{ padding:'10px', fontFamily:'monospace', fontWeight:700, color:'var(--c-green)' }}>
                      {euro(Object.values(liq).reduce((s,l)=>s+(parseFloat(l.credito)||0),0))}
                    </td>
                    <td style={{ padding:'10px', fontFamily:'monospace', fontWeight:700,
                      color:det.debitoNetto>0?'var(--c-red)':'var(--c-green)' }}>
                      {det.debitoNetto>0 ? `Debito: ${euro(det.debitoNetto)}` : `Credito: ${euro(det.totCredito-det.totDebito)}`}
                    </td>
                    <td colSpan={2} style={{ padding:'10px', fontFamily:'monospace', fontWeight:700, color:'var(--accent)' }}>
                      Versato totale: {euro(det.totVersato)}
                    </td>
                    <td colSpan={2} style={{ padding:'10px' }}>
                      <div style={{ display:'inline-block', padding:'6px 14px', borderRadius:'var(--radius-sm)',
                        background:det.saldo>0?'#FCEAEA':det.saldo<0?'#F0FFF4':'var(--bg)',
                        border:`1px solid ${det.saldo>0?'var(--c-red)':det.saldo<0?'var(--c-green)':'var(--border)'}`,
                        fontFamily:'monospace', fontWeight:700, fontSize:14,
                        color:det.saldo>0?'var(--c-red)':det.saldo<0?'var(--c-green)':'var(--text-faint)' }}>
                        {det.saldo>0 ? `${euro(det.saldo)} da versare`
                         : det.saldo<0 ? `${euro(Math.abs(det.saldo))} in eccesso`
                         : '✓ In pari'}
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
              {/* ── Allegati ─────────────────────────────────────────── */}
              <div style={{ marginTop:20 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
                  <div style={{ fontWeight:600, fontSize:14 }}>📎 Allegati</div>
                  <UploadOneDrive endpoint={`/api/iva/${scadenza.id}/allegati`} onUpload={() => loadAllegati()} addToast={addToast} label="📎 Allega documento" />
                </div>
                {allegati.length === 0 ? (
                  <div style={{ padding:'16px', background:'var(--bg)', borderRadius:'var(--radius-sm)',
                    border:'1px dashed var(--border)', textAlign:'center',
                    fontSize:13, color:'var(--text-faint)', cursor:'pointer' }}
                    onClick={() => fileRef.current.click()}>
                    📎 Clicca o trascina per allegare documenti (F24, ricevute, ecc.)
                  </div>
                ) : (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                    {allegati.map(a => (
                      <div key={a.id} style={{ display:'flex', alignItems:'center', gap:8,
                        padding:'8px 12px', background:'var(--bg)', border:'1px solid var(--border)',
                        borderRadius:'var(--radius-sm)' }}>
                        <span style={{ fontSize:18 }}>{fileIcon(a.nome)}</span>
                        <span style={{ fontSize:12, fontWeight:500, maxWidth:180,
                          whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{a.nome}</span>
                        <a href={`http://localhost:3001${a.url}`} target="_blank" rel="noreferrer"
                          className="btn btn-sm" style={{ padding:'2px 8px', fontSize:11 }}>Apri</a>
                        <button onClick={() => deleteAllegato(a.id)}
                          style={{ border:'none', background:'none', cursor:'pointer',
                            color:'var(--c-red)', fontSize:14 }}>×</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


export default function IVA({ addToast }) {
  const [tutteRighe, setTutteRighe] = useState([]);
  const [clienti, setClienti]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [q, setQ]                   = useState('');
  const [statoF, setStatoF]         = useState('');
  const [annoF, setAnnoF]           = useState('');
  const [anniAperti, setAnniAperti] = useState(new Set()); // anni espansi
  const [showForm, setShowForm]     = useState(false);
  const [editItem, setEditItem]     = useState(null);
  const [delItem, setDelItem]       = useState(null);
  const [saving, setSaving]         = useState(false);
  const [dettaglio, setDettaglio]   = useState(null);
  const [selected, setSelected]     = useState(new Set()); // id selezionati
  const [showBulk, setShowBulk]     = useState(false);     // modal aggiornamento massivo
  const [bulkStato, setBulkStato]   = useState('');
  const [bulkNote, setBulkNote]     = useState('');
  const [bulkSaving, setBulkSaving] = useState(false);

  useEffect(() => { api.getClienti({ limit: 300 }).then(d => setClienti(d.rows)); }, []);

  const [sort, setSort] = useState('denominazione');
  const [dir, setDir]   = useState('asc');
  const handleSort = (field) => {
    if (sort === field) setDir(d => d==='asc'?'desc':'asc');
    else { setSort(field); setDir('asc'); }
  };
  const sortRows = (rows) => [...rows].sort((a,b) => {
    let va = a[sort]||'', vb = b[sort]||'';
    const cmp = String(va).localeCompare(String(vb),'it',{numeric:true});
    return dir==='asc' ? cmp : -cmp;
  });
  const sortProps = { sort, dir, onSort: handleSort };

  const load = useCallback(() => {
    setLoading(true);
    // Carica tutto senza paginazione
    fetch('/api/scadenze?tipo=IVA&limit=9999&page=1')
      .then(r=>r.json())
      .then(j => { if(j.success) setTutteRighe(j.data.rows); })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  // Filtra localmente
  const righe = tutteRighe.filter(s => {
    if (statoF && s.stato !== statoF) return false;
    if (q) {
      const txt = [s.descrizione, s.denominazione, s.ragione_sociale, s.nome, s.cognome].join(' ').toLowerCase();
      if (!txt.includes(q.toLowerCase())) return false;
    }
    return true;
  });

  // Raggruppa per anno_imposta
  const gruppiAnno = {};
  righe.forEach(s => {
    const anno = s.anno_imposta || s.descrizione?.match(/(20\d{2})/)?.[1] || 'N/D';
    if (!gruppiAnno[anno]) gruppiAnno[anno] = [];
    gruppiAnno[anno].push(s);
  });
  const anniOrdinati = Object.keys(gruppiAnno).sort((a,b) => b.localeCompare(a));

  // Apri automaticamente l'anno filtrato o il primo
  useEffect(() => {
    if (annoF) {
      setAnniAperti(new Set([annoF]));
    } else if (anniOrdinati.length > 0 && anniAperti.size === 0) {
      setAnniAperti(new Set([anniOrdinati[0]]));
    }
  }, [annoF, anniOrdinati.join(',')]);

  const toggleAnno = (anno) => setAnniAperti(prev => {
    const s = new Set(prev);
    s.has(anno) ? s.delete(anno) : s.add(anno);
    return s;
  });

  const handleSave = async (formData) => {
    setSaving(true);
    try {
      formData.tipo = 'IVA';
      if (editItem) { await api.updateScadenza(editItem.id, formData); addToast('Dichiarazione aggiornata', 'success'); setEditItem(null); }
      else {
        const result = await api.createScadenza(formData);
        addToast(result.bulk ? `✅ Create ${result.inserite} dichiarazioni IVA` : 'Dichiarazione creata', 'success');
        setShowForm(false);
      }
      load();
    } catch (e) { addToast(e.message, 'error'); }
    finally { setSaving(false); }
  };

  const handleDelete = async () => {
    try { await api.deleteScadenza(delItem.id); addToast('Eliminata', 'success'); setDelItem(null); load(); }
    catch (e) { addToast(e.message, 'error'); }
  };

  const toggleRow = (id) => setSelected(prev => {
    const s = new Set(prev); s.has(id) ? s.delete(id) : s.add(id); return s;
  });
  const toggleAnnoSel = (rows) => {
    const ids = rows.map(r=>r.id);
    const allSel = ids.every(id => selected.has(id));
    setSelected(prev => {
      const s = new Set(prev);
      ids.forEach(id => allSel ? s.delete(id) : s.add(id));
      return s;
    });
  };

  const handleBulkUpdate = async () => {
    if (!bulkStato) { addToast('Seleziona uno stato', 'error'); return; }
    setBulkSaving(true);
    try {
      const ids = [...selected];
      await Promise.all(ids.map(id =>
        fetch(`/api/scadenze/${id}`, {
          method: 'PUT',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            // Recupera i dati originali dalla riga
            ...tutteRighe.find(r=>r.id===id),
            stato: bulkStato,
            note: bulkNote || tutteRighe.find(r=>r.id===id)?.note || '',
          })
        })
      ));
      addToast(`✅ ${ids.length} dichiarazioni aggiornate`, 'success');
      setSelected(new Set());
      setShowBulk(false);
      setBulkStato(''); setBulkNote('');
      load();
    } catch(e) { addToast(e.message, 'error'); }
    finally { setBulkSaving(false); }
  };

  const totale    = righe.reduce((s,r) => s+(r.importo||0), 0);
  const daVersare = righe.filter(r=>r.stato==='APERTA').reduce((s,r) => s+(r.importo||0), 0);

  const STATO_CONFIG = {
    'APERTA':       { cls:'pill-red',   bg:'#FFF5F5', border:'#FC8181', lbl:'Da preparare' },
    'IN_CORSO':     { cls:'pill-amber', bg:'#FFFBEB', border:'#F6AD55', lbl:'In preparazione' },
    'PREPARATA':    { cls:'pill-blue',  bg:'#EBF8FF', border:'#63B3ED', lbl:'Preparata' },
    'INVIATA':      { cls:'pill-green', bg:'#F0FFF4', border:'#68D391', lbl:'Inviata' },
    'COMPLETATA':   { cls:'pill-green', bg:'#F0FFF4', border:'#68D391', lbl:'Completata' },
    'SOSPESA':      { cls:'pill-gray',  bg:'#F7FAFC', border:'#A0AEC0', lbl:'Sospesa' },
    'ANNULLATA':    { cls:'pill-gray',  bg:'#F7FAFC', border:'#A0AEC0', lbl:'Annullata' },
    'NON_PREVISTA': { cls:'pill-gray',  bg:'#F7FAFC', border:'#A0AEC0', lbl:'Non prevista' },
  };
  const statoPill = (stato) => {
    const cfg = STATO_CONFIG[stato] || { cls:'pill-gray', lbl: stato };
    return <span className={`pill ${cfg.cls}`}>{cfg.lbl}</span>;
  };
  const rowBg = (stato, isSel) => {
    if (isSel) return 'var(--accent-light)';
    const cfg = STATO_CONFIG[stato];
    return cfg ? cfg.bg : 'var(--surface)';
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <div className="page-title">Dichiarazioni IVA</div>
          <div className="page-subtitle">{righe.length} pratiche</div>
        </div>
        <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ Nuova Dichiarazione</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14, marginBottom:24 }}>
        {[['Totale IVA', formatEuro(totale), 'var(--accent)'],
          ['Da versare', formatEuro(daVersare), 'var(--c-red)'],
          ['Pratiche', righe.length, 'var(--c-blue)']].map(([l,v,c]) => (
          <div key={l} className="kpi-card">
            <div className="kpi-accent" style={{background:c}} />
            <div className="kpi-label">{l}</div>
            <div className="kpi-value" style={{fontSize:22}}>{v}</div>
          </div>
        ))}
      </div>

      {/* Toolbar selezione massiva */}
      {selected.size > 0 && (
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12,
          padding:'10px 16px', background:'var(--accent-light)',
          border:'1px solid var(--accent)', borderRadius:'var(--radius)',
          flexWrap:'wrap' }}>
          <span style={{ fontWeight:600, fontSize:13, color:'var(--accent)' }}>
            {selected.size} {selected.size===1?'dichiarazione':'dichiarazioni'} selezionate
          </span>
          <button className="btn btn-primary btn-sm" onClick={() => setShowBulk(true)}>
            ✏ Aggiorna stato e note
          </button>
          <button className="btn btn-sm" style={{ color:'var(--text-faint)' }}
            onClick={() => setSelected(new Set())}>✕ Deseleziona tutto</button>
        </div>
      )}

      {/* Filtri */}
      <div className="filters-bar">
        <div className="search-box">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
          <input placeholder="Cerca cliente, descrizione…" value={q} onChange={e=>setQ(e.target.value)} />
        </div>
        <AnnoInput value={annoF} onChange={setAnnoF} placeholder="Anno imposta…" />
        <select className="form-control" style={{width:'auto'}} value={statoF} onChange={e=>setStatoF(e.target.value)}>
          <option value="">Tutti gli stati</option>
          <option value="APERTA">Da preparare</option>
          <option value="IN_CORSO">In preparazione</option>
          <option value="COMPLETATA">Inviata</option>
          <option value="ANNULLATA">Annullata</option>
        </select>
      </div>

      {/* Vista raggruppata per anno */}
      {loading ? <LoadingSpinner /> : anniOrdinati.length === 0 ? (
        <div className="card"><div className="empty-state">
          <div className="empty-state-icon">📋</div>
          <div className="empty-state-title">Nessuna dichiarazione IVA</div>
        </div></div>
      ) : anniOrdinati.map(anno => {
        const rows = gruppiAnno[anno];
        const aperto = anniAperti.has(anno);
        const totAnno = rows.reduce((s,r)=>s+(r.importo||0),0);
        const nAperte = rows.filter(r=>r.stato==='APERTA').length;
        const nInviate = rows.filter(r=>r.stato==='COMPLETATA').length;

        return (
          <div key={anno} className="card" style={{marginBottom:12}}>
            {/* Header anno — cliccabile */}
            <div onClick={()=>toggleAnno(anno)} style={{
              padding:'12px 16px', cursor:'pointer',
              display:'flex', alignItems:'center', gap:12,
              borderBottom: aperto ? '1px solid var(--border)' : 'none',
              background: aperto ? 'var(--accent-light)' : 'var(--surface)',
              borderRadius: aperto ? 'var(--radius) var(--radius) 0 0' : 'var(--radius)',
            }}>
              <span style={{fontSize:18}}>{aperto ? '▼' : '▶'}</span>
              <span style={{fontWeight:700, fontSize:16, color:'var(--accent)'}}>Anno {anno}</span>
              <span style={{fontSize:12, color:'var(--text-faint)', marginLeft:4}}>
                {rows.length} clienti
              </span>
              <div style={{marginLeft:'auto', display:'flex', gap:12, alignItems:'center'}}>
                {nAperte>0 && <span className="pill pill-red" style={{fontSize:11}}>{nAperte} da preparare</span>}
                {nInviate>0 && <span className="pill pill-green" style={{fontSize:11}}>{nInviate} inviate</span>}
                <span style={{fontFamily:'monospace', fontSize:13, fontWeight:600}}>
                  {totAnno>0 ? formatEuro(totAnno) : ''}
                </span>
              </div>
            </div>

            {/* Righe clienti — tutti senza paginazione */}
            {aperto && (
              <div className="table-wrap">
                <table>
                  <thead><tr>
                    <th style={{width:36, padding:'8px 10px'}}>
                      <input type="checkbox"
                        checked={rows.length>0 && rows.every(r=>selected.has(r.id))}
                        ref={el => { if(el) el.indeterminate = rows.some(r=>selected.has(r.id)) && !rows.every(r=>selected.has(r.id)); }}
                        onChange={() => toggleAnnoSel(rows)}
                        style={{accentColor:'var(--accent)', cursor:'pointer'}} />
                    </th>
                    <SortTh label="Cliente" field="denominazione" {...sortProps} />
                    <SortTh label="Note" field="note" {...sortProps} />
                    <SortTh label="Scadenza" field="data_scad" {...sortProps} />
                    <SortTh label="IVA Debito" field="importo" {...sortProps} />
                    <SortTh label="Stato" field="stato" {...sortProps} />
                    <th>Azioni</th>
                  </tr></thead>
                  <tbody>
                    {sortRows(rows).map(s => {
                      const isSel = selected.has(s.id);
                      return (
                        <tr key={s.id} style={{background: rowBg(s.stato, isSel),
                          borderLeft: `3px solid ${STATO_CONFIG[s.stato]?.border||'transparent'}`}}>
                          <td style={{padding:'8px 10px'}}>
                            <input type="checkbox" checked={isSel}
                              onChange={() => toggleRow(s.id)}
                              style={{accentColor:'var(--accent)', cursor:'pointer'}} />
                          </td>
                          <td className="fw-500" style={{fontSize:13}}>{clienteNome(s)||'—'}</td>
                          <td style={{fontSize:12, color:'var(--text-muted)', maxWidth:200,
                            whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}
                            title={s.note||s.descrizione}>
                            {s.note || <span style={{color:'var(--text-faint)', fontStyle:'italic'}}>{s.descrizione||'—'}</span>}
                          </td>
                          <td style={{fontSize:12}}>{formatDate(s.data_scad)}</td>
                          <td style={{fontFamily:'monospace', fontSize:12}}>{s.importo?formatEuro(s.importo):'—'}</td>
                          <td>{statoPill(s.stato)}</td>
                          <td><div style={{display:'flex', gap:4}}>
                            <button className="btn btn-sm btn-primary" onClick={()=>setDettaglio(s)} title="Dettaglio">📊</button>
                            <button className="btn btn-sm" onClick={()=>setEditItem(s)} title="Modifica">✎</button>
                            <button className="btn btn-sm btn-danger" onClick={()=>setDelItem(s)} title="Elimina">×</button>
                          </div></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}

      {/* Modal aggiornamento massivo */}
      {showBulk && (
        <Modal title={`Aggiorna ${selected.size} dichiarazioni`} onClose={() => setShowBulk(false)} size="sm">
          <div className="form-grid">
            <div className="form-group form-full">
              <label className="form-label">Nuovo stato *</label>
              <select className="form-control" value={bulkStato} onChange={e=>setBulkStato(e.target.value)}>
                <option value="">— Seleziona stato —</option>
                {Object.entries(STATO_CONFIG).map(([k,v]) => (
                  <option key={k} value={k}>{v.lbl}</option>
                ))}
              </select>
            </div>
            <div className="form-group form-full">
              <label className="form-label">Note (opzionale — sovrascrive le note esistenti)</label>
              <textarea className="form-control" value={bulkNote}
                onChange={e=>setBulkNote(e.target.value)} rows={3}
                placeholder="Es. Documenti ricevuti, in lavorazione…" />
            </div>
          </div>
          <div style={{fontSize:12, color:'var(--text-faint)', marginTop:8}}>
            Le modifiche verranno applicate a <strong>{selected.size}</strong> dichiarazioni selezionate.
          </div>
          <div className="modal-footer" style={{padding:'16px 0 0', borderTop:'1px solid var(--border)', marginTop:16}}>
            <button className="btn" onClick={()=>setShowBulk(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={handleBulkUpdate} disabled={bulkSaving||!bulkStato}>
              {bulkSaving ? 'Aggiornamento…' : `✅ Aggiorna ${selected.size} dichiarazioni`}
            </button>
          </div>
        </Modal>
      )}

      {(showForm || editItem) && (
        <Modal title={editItem ? 'Modifica Dichiarazione IVA' : 'Nuova Dichiarazione IVA'}
          onClose={() => { setShowForm(false); setEditItem(null); }}>
          <IVAForm initial={editItem||{}} clientiList={clienti} onSave={handleSave}
            onClose={()=>{ setShowForm(false); setEditItem(null); }} loading={saving} />
        </Modal>
      )}
      {delItem && <ConfirmDialog message={`Eliminare la dichiarazione "${delItem.descrizione}"?`}
        onConfirm={handleDelete} onCancel={()=>setDelItem(null)} />}
      {dettaglio && <IVADettaglio scadenza={dettaglio} onClose={()=>setDettaglio(null)} addToast={addToast} />}
    </div>
  );
}
